export const MAX_SUPPLIERS = 5;
export const CANONICAL_SUPPLIER_NUMBER_LENGTH = 10;

export interface SupplierOption {
  value: string;
  label: string;
  supplierNumber: string;
  supplierName: string;
  city?: string;
  region?: string;
  country?: string;
  sbmName?: string;
}

export function normalizeSupplierNumber(raw: string): string {
  const digits = raw.replace(/\D/g, '');
  return digits.padStart(CANONICAL_SUPPLIER_NUMBER_LENGTH, '0');
}

export function parsePastedSuppliers(text: string): string[] {
  return [
    ...new Set(
      text
        .split(/[,;\s]+/)
        .filter(Boolean)
        .map(normalizeSupplierNumber)
    )
  ];
}

export function parseSuppliersFromUrl(
  param: string | string[] | null
): string[] {
  const value = Array.isArray(param) ? param.join(',') : param;
  if (!value) return [];
  return [
    ...new Set(
      value
        .split(',')
        .map((supplierNumber) => supplierNumber.trim())
        .filter(Boolean)
        .map(normalizeSupplierNumber)
    )
  ].slice(0, MAX_SUPPLIERS);
}

export function serializeSuppliersToUrl(numbers: string[]): string {
  return numbers.join(',');
}

export function mapSupplierResult(item: any): SupplierOption {
  const supplierNumber = String(item.supplierNumber);
  const supplierName = item.supplierName ?? '';
  return {
    value: supplierNumber,
    supplierNumber,
    supplierName,
    label: `${supplierNumber} - ${supplierName}`,
    city: item.city ?? '',
    region: item.state ?? '',
    country: item.country ?? ''
  };
}

export function buildPasteSummary({
  added,
  alreadySelected,
  notFound,
  skippedForMax
}: {
  added: number;
  alreadySelected: number;
  notFound: string[];
  skippedForMax: number;
}): string {
  const parts = [`${added} added`];
  if (alreadySelected) parts.push(`${alreadySelected} already selected`);
  if (notFound.length)
    parts.push(`${notFound.length} not found: ${notFound.join(', ')}`);
  if (skippedForMax)
    parts.push(`${skippedForMax} skipped (max ${MAX_SUPPLIERS})`);
  return parts.join(' · ');
}
